"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useTrigger = function (initialTrigger, triggerProps, tag) {
  if (tag === void 0) {
    tag = 'span';
  }
  if (!initialTrigger) return {};
  const trigger = /*#__PURE__*/_react.default.isValidElement(initialTrigger) ? /*#__PURE__*/_react.default.cloneElement(initialTrigger, {
    tabIndex: tag === 'button' ? undefined : 0,
    ...triggerProps
  }, initialTrigger.props.children) : /*#__PURE__*/_react.default.createElement(tag, {
    tabIndex: tag === 'button' ? undefined : 0,
    ...triggerProps
  }, initialTrigger);
  return {
    trigger
  };
};
var _default = exports.default = useTrigger;